module.exports = __webpack_public_path__ + "static/media/2020.8.16二居为老人送清凉活动.473fab98.jpg";